import {ApiService} from './../apiService.js'
const ApiService_ = new ApiService;
const client = ApiService_.client;
const apiurl = ApiService_.API_URL;

export class ZohoService{
    static submit(ticket){
        const url = apiurl+`zoho/ticket/create`;
        return client.post(url, ticket, {
            'headers': {
                'Content-Type': 'application/json'
            }
        });
    }
}